import React from 'react';

class TsSprintDetailItemTitle extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}

	render () {
		return (
			<h5 className="proxima-bold col w200p txtmiddle h6-like">
				{this.props.title}
			</h5>
		);
	}
}

export default TsSprintDetailItemTitle;


// WEBPACK FOOTER //
// ./src/js/TsSprintDetailItemTitle.jsx